import React, { useMemo } from 'react'
import { makeStyles } from '@material-ui/core'
import { Tooltip } from '.'
import CSV_ICON from '../../../../assets/svg/export-icons/icon_file_csv.svg'
import XLS_ICON from '../../../../assets/svg/export-icons/icon_file_xls.svg'
import PDF_ICON from '../../../../assets/svg/export-icons/icon_file_pdf.svg'

const FILE_TYPE_IMG = {
    csv: CSV_ICON,
    excel: XLS_ICON,
    pdf: PDF_ICON
}

const SIZES = {
    small: 18,
    medium: 28,
    regular: 32,
    big: 36
}

const getTooltipText = locale =>
    locale
        ? {
              csv: locale.common.exportCsv,
              excel: locale.common.exportExcel,
              pdf: locale.common.exportPdf
          }
        : {}

const useStyles = makeStyles(theme => ({
    fileTypeLogo: {
        width({ size }) {
            return SIZES[size] || SIZES.regular
        },
        marginLeft: 8,
        cursor: 'pointer',
        '&:hover': {
            opacity: '0.8'
        }
    }
}))

export const ExportFileIcon = ({ size = 'regular', fileType, locale }) => {
    const cls = useStyles({ size })
    const tooltipText = useMemo(() => getTooltipText(locale)[fileType], [
        locale
    ])

    return (
        <Tooltip hover text={tooltipText}>
            <img className={cls.fileTypeLogo} src={FILE_TYPE_IMG[fileType]} />
        </Tooltip>
    )
}
